import { ELEMENT_TYPE_UPLOAD } from '@/plugins/composition-renderer/constants';
import store from '@/store';
import { GETTER_PRODUCT_PRINT_PLATE } from '@/store/modules/product/getters';
import { useControlLayerStore } from '@/store-pinia/control-layer';
import { useCustomerUploadsStore } from '@/store-pinia/customerUploads';
import {
  useCompositionWarningStore,
  WARNING_IMAGE_TOO_SMALL
} from '@/store-pinia/composition-warnings';

// eslint-disable-next-line no-unused-vars
export default ({ element, printPlate, printSide }) => {
  if (element.type !== ELEMENT_TYPE_UPLOAD) {
    return null;
  }

  const minDpi = useControlLayerStore().configData.uploadMinDpi;
  const hundredPercentMaximum =
    store.getters[GETTER_PRODUCT_PRINT_PLATE](printSide).heightInInch * minDpi;

  const customerUploadsStore = useCustomerUploadsStore();
  customerUploadsStore.loadMetaData(element.srcFile);

  const compositionWarningStore = useCompositionWarningStore();

  return element => {
    const metaData = customerUploadsStore.getMetaData(element.srcFile);

    if (null === metaData) {
      return;
    }

    if (metaData.height < (hundredPercentMaximum * element.height) / 100) {
      compositionWarningStore.addWarning(element.uid, WARNING_IMAGE_TOO_SMALL);
    } else {
      compositionWarningStore.removeWarning(
        element.uid,
        WARNING_IMAGE_TOO_SMALL
      );
    }
  };
};
